import {useContext} from 'react'
import {SalesRepReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import SalesRepReportRow from './SalesRepReportRow'
import {parseSalesRepReportRow} from '../../parsings'
import {SALES_REP_REPORT_COLUMNS} from '../../utils'
import {formatPrice} from '../../../../utils/common'

const SalesRepReportTable = () => {
  const {salesRepData, isSalesRepLoading, onSalesRepSortingChange, filters} =
    useContext(SalesRepReportContext)

  return (
    <DynamicTable
      data={salesRepData}
      sortableColumns={SALES_REP_REPORT_COLUMNS}
      loading={isSalesRepLoading}
      TableRow={SalesRepReportRow}
      noDataMessage='No sales rep reports found'
      filters={filters}
      onSortingChange={onSalesRepSortingChange}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
      rowParsingFunction={parseSalesRepReportRow}
      tableFooter={({columnTotals}: any) => (
        <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
          <tr>
            <td>TOTAL</td>
            <td>{columnTotals.total_order_count}</td>
            <td>{formatPrice(columnTotals.total_discount, false)}</td>
          </tr>
        </tfoot>
      )}
    />
  )
}

export default SalesRepReportTable
